var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "fieldset",
    { staticClass: "option-select option-select--buttons" },
    [
      _vm.label
        ? _c("legend", { staticClass: "option-select__legend" }, [
            _c("span", { staticClass: "option-select__legend--title" }, [
              _vm._v(_vm._s(_vm.label)),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "option-select__label-wrapper" },
        _vm._l(_vm.optionSet, function (option) {
          return _c(
            "label",
            {
              staticClass: "option-select__label",
              class: { "is-selected": option.value === _vm.value },
              attrs: { tabindex: "0", disabled: option.disabled },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "space", 32, $event.key, [
                      " ",
                      "Spacebar",
                    ])
                  )
                    return null
                  return _vm.onChange(option.value)
                },
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "space", 32, $event.key, [
                      " ",
                      "Spacebar",
                    ])
                  )
                    return null
                  $event.preventDefault()
                },
              },
            },
            [
              _c("div", { staticClass: "option-select__label__title" }, [
                _vm._v(_vm._s(option.label)),
              ]),
              _c("div", { staticClass: "option-select__label__price" }, [
                _c(
                  "span",
                  { staticClass: "option-select__label__price__text" },
                  [_vm._v(_vm._s(_vm._f("money")(option.price)))]
                ),
                option.discount
                  ? _c(
                      "span",
                      { staticClass: "option-select__label__price__savings" },
                      [_vm._v("Save " + _vm._s(option.discount) + "%")]
                    )
                  : _vm._e(),
              ]),
              _c("input", {
                staticClass: "u-sr-only",
                attrs: {
                  type: "radio",
                  tabindex: "-1",
                  id: option.label,
                  disabled: option.disabled,
                  name: "variant",
                },
                domProps: { value: _vm.currentValue },
                on: {
                  change: function ($event) {
                    $event.preventDefault()
                    return _vm.onChange(option.value)
                  },
                },
              }),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }